import type { RefundOrigin } from '../receipt-model-api/receipt-model-api.types';

import http from './contract-formalization-api.http';
import { ContractFormalizationAPI } from './contract-formalization-api.types';

export default {
  cancelContract: async (
    projectId: string,
    reason: string,
    force?: boolean,
    cancelledDate?: string,
    origin?: RefundOrigin,
  ) => {
    const res = await http.post(`/v1/contract/${projectId}/cancel`, {
      reason,
      ...(origin && { origin }),
      ...(force !== undefined && { force }),
      ...(cancelledDate && { cancelled_date: cancelledDate }),
    });
    return res.data;
  },

  getFormalizationInfo: async (projectId: string) => {
    const res = await http.get<ContractFormalizationAPI.FormalizationsInfoResponse>(
      `/v1/formalizations/info/${projectId}`,
    );
    return res.data;
  },

  resendSignature: async (projectId: string) => {
    const res = await http.post(`/v1/formalizations/${projectId}/contract/resend`);
    return res.data;
  },
};
